import '../styles/header.scss';
import { Flex } from "@chakra-ui/react";
import HeaderLogo from './HeaderLogo';
import NavigationMenuHeader from './NavigationMenuHeader';
import DsrNavigationDrawerMenu from '../../sidebar/components/DsrNavigationDrawerMenu';


export default function MobileHeader({ className, history }) {

	const pathname = history ? history.location.pathname : '';
	const noHeaderRequired = pathname ? /^\/(dsr|pdsr|archived)/.test(pathname) : false;

	function renderNavigationMenu() {
		switch (pathname) {
			//"No distraction" pages
			case ('/welcome'):
			case ('/setup-profile'):
			case ('/organization/choose-plan'): {
				return null
			}
			default:
				return (
					<Flex ml='8%' align='center' justify='flex-start' mr='0.5em'>
						<DsrNavigationDrawerMenu darkMode={false} />
						<NavigationMenuHeader isMobileView={true} />
					</Flex>
				)

		}
	}

	if (noHeaderRequired) {
		return null
	} else
		return (
			<nav className={`${className} header header--default`}>
				{renderNavigationMenu()}
				<HeaderLogo isMobileView={true} />
			</nav>
		);
}
